import BossModel from '@/models/BossModel'
import Day from "@/models/Proposal/Presentation/Day/Day";
import File from "@/models/File/File";
import OptionalDay from "@/models/Proposal/Presentation/OptionalDay/OptionalDay";
import Proposal from "@/models/Proposal/Proposal";
import sortBy from "lodash/sortBy";
import {pick} from "lodash";

export default class Presentation extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'proposal/presentation';

    /**
     *
     * @type {string}
     */
    static entity = 'proposalPresentations';

    static fields() {
        return {
            id: this.number(null).nullable(),
            proposal_id: this.number(null).nullable(),
            file_id: this.number(null).nullable(),
            created_at: this.attr(null),
            title: this.attr(null),
            intro: this.attr(null),
            included: this.attr(null),
            excluded: this.attr(null),
            important: this.attr(null),
            conditions: this.attr(null),
            day_to_day: this.attr(null),
            pricing_title: this.attr(null),
            pricing_information: this.attr(null),
            accommodations: this.attr(null),
            car_camper_rental: this.attr(null),
            pricing_adult: this.attr(null),
            pricing_child: this.attr(null),
            pricing_baby: this.attr(null),
            pricing_total: this.attr(null),
            email_subject: this.attr(null),
            email_content: this.attr(null),
            excursions: this.attr(null),
            preparation: this.attr(null),
            flight_schedule: this.attr([]),
            is_upsell_visible: this.boolean(false),
            proposal: this.belongsTo(Proposal, 'proposal_id', 'id'),
            file: this.belongsTo(File, 'file_id', 'id'),
            days: this.hasMany(Day, 'proposal_presentation_id', 'id'),
            optionalDays: this.hasMany(OptionalDay, 'proposal_presentation_id', 'id'),
        }
    }

    Days() {
        return sortBy(this.getRelated('days'), ['start_at', 'id']);
    }

    OptionalDays() {
        return sortBy(this.getRelated('OptionalDays'), ['sort_order', 'id']);
    }

    async UpdatePerField(newPresentation, onlyFields = []) {
        let updateId = this.id;

        await this.constructor.api().action('concept/' + newPresentation.proposal_id).getSingle().then((UpdatedPresentation) => {
            updateId = UpdatedPresentation.id;
        });

        if (onlyFields.length > 0) {
            return this.constructor.api().updateById(updateId, pick(newPresentation, onlyFields));
        }

        let promises = [];

        promises.push(this.constructor.api().updateById(updateId, pick(newPresentation, ['title', 'intro', 'included', 'excluded']), false));
        promises.push(this.constructor.api().updateById(updateId, pick(newPresentation, ['important', 'conditions', 'day_to_day']), false));
        promises.push(this.constructor.api().updateById(updateId, pick(newPresentation, ['pricing_title', 'pricing_information', 'pricing_adult', 'pricing_child', 'pricing_baby', 'pricing_total']), false));
        promises.push(this.constructor.api().updateById(updateId, pick(newPresentation, ['accommodations', 'car_camper_rental']), false));
        promises.push(this.constructor.api().updateById(updateId, pick(newPresentation, ['email_subject', 'email_content']), false));
        promises.push(this.constructor.api().updateById(updateId, pick(newPresentation, ['excursions', 'preparation']), false));

        await Promise.all(promises);

        return this.constructor.api().find(updateId);
    }


    static byProposal(proposalId) {
        return this.all().filter(item => item.proposal_id == proposalId);
    }

    static loadOrCreateByProposal(proposalId) {
        return this.api()
            .where('proposal_id', proposalId)
            .with([
                'days.publicImage',
                'proposal',
                'optionalDays',
                'optionalDays.product.agentPreset'
            ])
            .orderBy('created_at', 'desc')
            .first()
            .then(presentation => {
                if (!presentation) {
                    return Presentation.api().action('concept/' + proposalId).getSingle()
                        .then(presentation => {
                            return presentation;
                        });
                }

                return presentation;
            });
    }

    /**
     *
     * @param view
     * @returns {Promise<AxiosResponse<T>>}
     * @constructor
     */
    proposalPreview(view) {
        return this.constructor.api().action(this.id + '/preview/' + view).getSingle(false);
    }

}
